module.exports = __webpack_public_path__ + "static/img/modal_flow.f53461c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/floor9/modal_flow.png
// module id = WaUv
// module chunks = 2